(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-modal"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-modal"], factory);
	else if(typeof exports === 'object')
		exports["ReactImageLightbox"] = factory(require("react"), require("react-modal"));
	else
		root["ReactImageLightbox"] = factory(root["react"], root["react-modal"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_72__, __WEBPACK_EXTERNAL_MODULE_73__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(28).default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(23)('wks')
	  , uid        = __webpack_require__(24)
	  , Symbol     = __webpack_require__(2).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(11)
	  , createDesc = __webpack_require__(21);
	module.exports = __webpack_require__(7) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(19)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(6)
	  , IE8_DOM_DEFINE = __webpack_require__(43)
	  , toPrimitive    = __webpack_require__(58)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(23)('keys')
	  , uid    = __webpack_require__(24);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(44)
	  , defined = __webpack_require__(9);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(16)
	  , TAG = __webpack_require__(1)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10)
	  , document = __webpack_require__(2).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(47)
	  , $export        = __webpack_require__(41)
	  , redefine       = __webpack_require__(53)
	  , hide           = __webpack_require__(4)
	  , has            = __webpack_require__(8)
	  , Iterators      = __webpack_require__(5)
	  , $iterCreate    = __webpack_require__(45)
	  , setToStringTag = __webpack_require__(22)
	  , getPrototypeOf = __webpack_require__(50)
	  , ITERATOR       = __webpack_require__(1)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f
	  , has = __webpack_require__(8)
	  , TAG = __webpack_require__(1)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(2)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(54)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(20)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(62);
	var global        = __webpack_require__(2)
	  , hide          = __webpack_require__(4)
	  , Iterators     = __webpack_require__(5)
	  , TO_STRING_TAG = __webpack_require__(1)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Min image zoom level
	var MIN_ZOOM_LEVEL = exports.MIN_ZOOM_LEVEL = 0;
	
	// Max image zoom level
	var MAX_ZOOM_LEVEL = exports.MAX_ZOOM_LEVEL = 300;
	
	// Size ratio between previous and next zoom levels
	var ZOOM_RATIO = exports.ZOOM_RATIO = 1.007;
	
	// How much to increase/decrease the zoom level when the zoom buttons are clicked
	var ZOOM_BUTTON_INCREMENT_SIZE = exports.ZOOM_BUTTON_INCREMENT_SIZE = 100;
	
	// Used to judge the amount of horizontal scroll needed to initiate a image move
	var WHEEL_MOVE_X_THRESHOLD = exports.WHEEL_MOVE_X_THRESHOLD = 200;
	
	// Used to judge the amount of vertical scroll needed to initiate a zoom action
	var WHEEL_MOVE_Y_THRESHOLD = exports.WHEEL_MOVE_Y_THRESHOLD = 1;
	
	var KEYS = exports.KEYS = {
	    ESC: 27,
	    LEFT_ARROW: 37,
	    RIGHT_ARROW: 39
	};
	
	// Actions
	var ACTION_NONE = exports.ACTION_NONE = 0;
	var ACTION_MOVE = exports.ACTION_MOVE = 1;
	var ACTION_SWIPE = exports.ACTION_SWIPE = 2;
	var ACTION_PINCH = exports.ACTION_PINCH = 3;
	var ACTION_ROTATE = exports.ACTION_ROTATE = 4;
	
	// Events source
	var SOURCE_ANY = exports.SOURCE_ANY = 0;
	var SOURCE_MOUSE = exports.SOURCE_MOUSE = 1;
	var SOURCE_TOUCH = exports.SOURCE_TOUCH = 2;
	var SOURCE_POINTER = exports.SOURCE_POINTER = 3;
	
	// Minimal swipe distance
	var MIN_SWIPE_DISTANCE = exports.MIN_SWIPE_DISTANCE = 200;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * react-image-lightbox
	                                                                                                                                                                                                                                                                   * Copyright 2016 Chris Fritz All rights reserved.
	                                                                                                                                                                                                                                                                   * @license Open source under the MIT License
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(72);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(70);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(73);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _util = __webpack_require__(29);
	
	var _constant = __webpack_require__(27);
	
	var _style = __webpack_require__(67);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Add fallback classes for browsers without flexbox support
	var styles = _style2.default;
	var _ieVersion = (0, _util.getIEVersion)();
	if (_ieVersion < 10) {
	    styles = _extends({}, styles, {
	        toolbarSide: styles.toolbarSide + ' ' + styles.toolbarSideNoFlex,
	        toolbarLeftSide: styles.toolbarLeftSide + ' ' + styles.toolbarLeftSideNoFlex,
	        toolbarRightSide: styles.toolbarRightSide + ' ' + styles.toolbarRightSideNoFlex
	    });
	}
	
	var ReactImageLightbox = function (_Component) {
	    _inherits(ReactImageLightbox, _Component);
	
	    function ReactImageLightbox(props) {
	        _classCallCheck(this, ReactImageLightbox);
	
	        var _this = _possibleConstructorReturn(this, (ReactImageLightbox.__proto__ || Object.getPrototypeOf(ReactImageLightbox)).call(this, props));
	
	        _this.state = {
	            //-----------------------------
	            // Animation
	            //-----------------------------
	
	            // Lightbox is closing
	            // When Lightbox is mounted, if animation is enabled it will open with the reverse of the closing animation
	            isClosing: !props.animationDisabled,
	
	            // Component parts should animate (e.g., when images are moving, or image is being zoomed)
	            shouldAnimate: false,
	
	            //-----------------------------
	            // Zoom settings
	            //-----------------------------
	            // Zoom level of image
	            zoomLevel: _constant.MIN_ZOOM_LEVEL,
	
	            //-----------------------------
	            // Image position settings
	            //-----------------------------
	            // Horizontal offset from center
	            offsetX: 0,
	
	            // Vertical offset from center
	            offsetY: 0
	        };
	
	        _this.closeIfClickInner = _this.closeIfClickInner.bind(_this);
	        _this.handleImageDoubleClick = _this.handleImageDoubleClick.bind(_this);
	        _this.handleImageMouseWheel = _this.handleImageMouseWheel.bind(_this);
	        _this.handleKeyInput = _this.handleKeyInput.bind(_this);
	        _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	        _this.handleOuterMousewheel = _this.handleOuterMousewheel.bind(_this);
	        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
	        _this.handleTouchMove = _this.handleTouchMove.bind(_this);
	        _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
	        _this.handlePointerEvent = _this.handlePointerEvent.bind(_this);
	        _this.handleCaptionMousewheel = _this.handleCaptionMousewheel.bind(_this);
	        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	        _this.handleZoomInButtonClick = _this.handleZoomInButtonClick.bind(_this);
	        _this.handleZoomOutButtonClick = _this.handleZoomOutButtonClick.bind(_this);
	        _this.requestClose = _this.requestClose.bind(_this);
	        _this.requestMoveNext = _this.requestMoveNext.bind(_this);
	        _this.requestMovePrev = _this.requestMovePrev.bind(_this);
	        return _this;
	    }
	
	    _createClass(ReactImageLightbox, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // Timeouts - always clear it before umount
	            this.timeouts = [];
	
	            // Current action
	            this.currentAction = _constant.ACTION_NONE;
	
	            // Events source
	            this.eventsSource = _constant.SOURCE_ANY;
	
	            // Empty pointers list
	            this.pointerList = [];
	
	            // Prevent inner close
	            this.preventInnerClose = false;
	            this.preventInnerCloseTimeout = null;
	
	            // Whether event listeners for keyboard and mouse input have been attached or not
	            this.listenersAttached = false;
	
	            // Used to disable animation when changing props.mainSrc|nextSrc|prevSrc
	            this.keyPressed = false;
	
	            // Used to store load state / dimensions of images
	            this.imageCache = {};
	
	            // Time the last keydown event was called (used in keyboard action rate limiting)
	            this.lastKeyDownTime = 0;
	
	            // Used for debouncing window resize event
	            this.resizeTimeout = null;
	
	            // Used to determine when actions are triggered by the scroll wheel
	            this.wheelActionTimeout = null;
	            this.resetScrollTimeout = null;
	            this.scrollX = 0;
	            this.scrollY = 0;
	
	            // Used in panning zoomed images
	            this.moveStartX = 0;
	            this.moveStartY = 0;
	            this.moveStartOffsetX = 0;
	            this.moveStartOffsetY = 0;
	
	            // Used to swipe
	            this.swipeStartX = 0;
	            this.swipeStartY = 0;
	            this.swipeEndX = 0;
	            this.swipeEndY = 0;
	
	            // Used to pinch
	            this.pinchTouchList = null;
	            this.pinchDistance = 0;
	
	            // Used to differentiate between images with identical src
	            this.keyCounter = 0;
	
	            // Used to detect a move when all src's remain unchanged (four or more of the same image in a row)
	            this.moveRequested = false;
	
	            if (!this.props.animationDisabled) {
	                // Make opening animation play
	                this.setState({ isClosing: false });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.mounted = true;
	            ReactImageLightbox.loadStyles();
	            this.attachListeners();
	
	            this.loadAllImages();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            // Wait for move...
	            return !this.moveRequested;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            // Iterate through the source types for prevProps and nextProps to
	            //  determine if any of the sources changed
	            var sourcesChanged = false;
	            var prevSrcDict = {};
	            var nextSrcDict = {};
	            this.getSrcTypes().forEach(function (srcType) {
	                if (_this2.props[srcType.name] !== nextProps[srcType.name]) {
	                    sourcesChanged = true;
	
	                    prevSrcDict[_this2.props[srcType.name]] = true;
	                    nextSrcDict[nextProps[srcType.name]] = true;
	                }
	            });
	
	            if (sourcesChanged || this.moveRequested) {
	                // Reset the loaded state for images not rendered next
	                Object.keys(prevSrcDict).forEach(function (prevSrc) {
	                    if (!(prevSrc in nextSrcDict) && prevSrc in _this2.imageCache) {
	                        _this2.imageCache[prevSrc].loaded = false;
	                    }
	                });
	
	                this.moveRequested = false;
	
	                // Load any new images
	                this.loadAllImages(nextProps);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.mounted = false;
	            this.detachListeners();
	            this.timeouts.forEach(function (tid) {
	                return clearTimeout(tid);
	            });
	        }
	    }, {
	        key: 'setTimeout',
	        value: function (_setTimeout) {
	            function setTimeout(_x, _x2) {
	                return _setTimeout.apply(this, arguments);
	            }
	
	            setTimeout.toString = function () {
	                return _setTimeout.toString();
	            };
	
	            return setTimeout;
	        }(function (func, time) {
	            var _this3 = this;
	
	            var id = setTimeout(function () {
	                _this3.timeouts = _this3.timeouts.filter(function (tid) {
	                    return tid !== id;
	                });
	                func();
	            }, time);
	            this.timeouts.push(id);
	            return id;
	        })
	    }, {
	        key: 'clearTimeout',
	        value: function (_clearTimeout) {
	            function clearTimeout(_x3) {
	                return _clearTimeout.apply(this, arguments);
	            }
	
	            clearTimeout.toString = function () {
	                return _clearTimeout.toString();
	            };
	
	            return clearTimeout;
	        }(function (id) {
	            this.timeouts = this.timeouts.filter(function (tid) {
	                return tid !== id;
	            });
	            clearTimeout(id);
	        })
	
	        // Attach key and mouse input events
	
	    }, {
	        key: 'attachListeners',
	        value: function attachListeners() {
	            if (!this.listenersAttached && typeof window !== 'undefined') {
	                window.addEventListener('resize', this.handleWindowResize);
	                window.addEventListener('mouseup', this.handleMouseUp);
	                window.addEventListener('touchend', this.handleTouchEnd);
	                window.addEventListener('touchcancel', this.handleTouchEnd);
	                window.addEventListener('pointerdown', this.handlePointerEvent);
	                window.addEventListener('pointermove', this.handlePointerEvent);
	                window.addEventListener('pointerup', this.handlePointerEvent);
	                window.addEventListener('pointercancel', this.handlePointerEvent);
	                // Have to add an extra mouseup handler to catch mouseup events outside of the window
	                //  if the page containing the lightbox is displayed in an iframe
	                if ((0, _util.isInSameOriginIframe)()) {
	                    window.top.addEventListener('mouseup', this.handleMouseUp);
	                    window.top.addEventListener('touchend', this.handleTouchEnd);
	                    window.top.addEventListener('touchcancel', this.handleTouchEnd);
	                    window.top.addEventListener('pointerdown', this.handlePointerEvent);
	                    window.top.addEventListener('pointermove', this.handlePointerEvent);
	                    window.top.addEventListener('pointerup', this.handlePointerEvent);
	                    window.top.addEventListener('pointercancel', this.handlePointerEvent);
	                }
	
	                this.listenersAttached = true;
	            }
	        }
	
	        // Change zoom level
	
	    }, {
	        key: 'changeZoom',
	        value: function changeZoom(zoomLevel, clientX, clientY) {
	            // Ignore if zoom disabled
	            if (!this.props.enableZoom) {
	                return;
	            }
	
	            // Constrain zoom level to the set bounds
	            var nextZoomLevel = Math.max(_constant.MIN_ZOOM_LEVEL, Math.min(_constant.MAX_ZOOM_LEVEL, zoomLevel));
	
	            // Ignore requests that don't change the zoom level
	            if (nextZoomLevel === this.state.zoomLevel) {
	                return;
	            } else if (nextZoomLevel === _constant.MIN_ZOOM_LEVEL) {
	                // Snap back to center if zoomed all the way out
	                return this.setState({
	                    zoomLevel: nextZoomLevel,
	                    offsetX: 0,
	                    offsetY: 0
	                });
	            }
	
	            var imageBaseSize = this.getBestImageForType('mainSrc');
	            if (imageBaseSize === null) {
	                return;
	            }
	
	            var currentZoomMultiplier = this.getZoomMultiplier();
	            var nextZoomMultiplier = this.getZoomMultiplier(nextZoomLevel);
	
	            // Default to the center of the image to zoom when no mouse position specified
	            var boxRect = this.getLightboxRect();
	            var pointerX = typeof clientX !== 'undefined' ? clientX - boxRect.left : boxRect.width / 2;
	            var pointerY = typeof clientY !== 'undefined' ? clientY - boxRect.top : boxRect.height / 2;
	
	            var currentImageOffsetX = (boxRect.width - imageBaseSize.width * currentZoomMultiplier) / 2;
	            var currentImageOffsetY = (boxRect.height - imageBaseSize.height * currentZoomMultiplier) / 2;
	
	            var currentImageRealOffsetX = currentImageOffsetX - this.state.offsetX;
	            var currentImageRealOffsetY = currentImageOffsetY - this.state.offsetY;
	
	            var currentPointerXRelativeToImage = (pointerX - currentImageRealOffsetX) / currentZoomMultiplier;
	            var currentPointerYRelativeToImage = (pointerY - currentImageRealOffsetY) / currentZoomMultiplier;
	
	            var nextImageRealOffsetX = pointerX - currentPointerXRelativeToImage * nextZoomMultiplier;
	            var nextImageRealOffsetY = pointerY - currentPointerYRelativeToImage * nextZoomMultiplier;
	
	            var nextImageOffsetX = (boxRect.width - imageBaseSize.width * nextZoomMultiplier) / 2;
	            var nextImageOffsetY = (boxRect.height - imageBaseSize.height * nextZoomMultiplier) / 2;
	
	            var nextOffsetX = nextImageOffsetX - nextImageRealOffsetX;
	            var nextOffsetY = nextImageOffsetY - nextImageRealOffsetY;
	
	            // When zooming out, limit the offset so things don't get left askew
	            if (this.currentAction !== _constant.ACTION_PINCH) {
	                var maxOffsets = this.getMaxOffsets();
	                if (this.state.zoomLevel > nextZoomLevel) {
	                    nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, nextOffsetX));
	                    nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, nextOffsetY));
	                }
	            }
	
	            this.setState({
	                zoomLevel: nextZoomLevel,
	                offsetX: nextOffsetX,
	                offsetY: nextOffsetY
	            });
	        }
	    }, {
	        key: 'closeIfClickInner',
	        value: function closeIfClickInner(event) {
	            if (!this.preventInnerClose && event.target.className.search(/\bril-inner\b/) > -1) {
	                this.requestClose(event);
	            }
	        }
	    }, {
	        key: 'setPreventInnerClose',
	        value: function setPreventInnerClose() {
	            var _this4 = this;
	
	            if (this.preventInnerCloseTimeout) {
	                this.clearTimeout(this.preventInnerCloseTimeout);
	            }
	            this.preventInnerClose = true;
	            this.preventInnerCloseTimeout = this.setTimeout(function () {
	                _this4.preventInnerClose = false;
	                _this4.preventInnerCloseTimeout = null;
	            }, 100);
	        }
	
	        // Detach key and mouse input events
	
	    }, {
	        key: 'detachListeners',
	        value: function detachListeners() {
	            if (this.listenersAttached) {
	                window.removeEventListener('resize', this.handleWindowResize);
	                window.removeEventListener('mouseup', this.handleMouseUp);
	                window.removeEventListener('touchend', this.handleTouchEnd);
	                window.removeEventListener('touchcancel', this.handleTouchEnd);
	                window.removeEventListener('pointerdown', this.handlePointerEvent);
	                window.removeEventListener('pointermove', this.handlePointerEvent);
	                window.removeEventListener('pointerup', this.handlePointerEvent);
	                window.removeEventListener('pointercancel', this.handlePointerEvent);
	                if ((0, _util.isInSameOriginIframe)()) {
	                    window.top.removeEventListener('mouseup', this.handleMouseUp);
	                    window.top.removeEventListener('touchend', this.handleTouchEnd);
	                    window.top.removeEventListener('touchcancel', this.handleTouchEnd);
	                    window.top.removeEventListener('pointerdown', this.handlePointerEvent);
	                    window.top.removeEventListener('pointermove', this.handlePointerEvent);
	                    window.top.removeEventListener('pointerup', this.handlePointerEvent);
	                    window.top.removeEventListener('pointercancel', this.handlePointerEvent);
	                }
	
	                this.listenersAttached = false;
	            }
	        }
	
	        // Get info for the best suited image to display with the given srcType
	
	    }, {
	        key: 'getBestImageForType',
	        value: function getBestImageForType(srcType) {
	            var imageSrc = this.props[srcType];
	            var fitSizes = {};
	
	            if (this.isImageLoaded(imageSrc)) {
	                // Use full-size image if available
	                fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height);
	            } else if (this.isImageLoaded(this.props[srcType + 'Thumbnail'])) {
	                // Fall back to using thumbnail if the image has not been loaded
	                imageSrc = this.props[srcType + 'Thumbnail'];
	                fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height, true);
	            } else {
	                return null;
	            }
	
	            return {
	                src: imageSrc,
	                height: fitSizes.height,
	                width: fitSizes.width
	            };
	        }
	
	        // Get sizing for when an image is larger than the window
	
	    }, {
	        key: 'getFitSizes',
	        value: function getFitSizes(width, height, stretch) {
	            var boxSize = this.getLightboxRect();
	            var maxHeight = boxSize.height - this.props.imagePadding * 2;
	            var maxWidth = boxSize.width - this.props.imagePadding * 2;
	
	            if (!stretch) {
	                maxHeight = Math.min(maxHeight, height);
	                maxWidth = Math.min(maxWidth, width);
	            }
	
	            var maxRatio = maxWidth / maxHeight;
	            var srcRatio = width / height;
	
	            if (maxRatio > srcRatio) {
	                // height is the constraining dimension of the photo
	                return {
	                    width: width * maxHeight / height,
	                    height: maxHeight
	                };
	            }
	
	            return {
	                width: maxWidth,
	                height: height * maxWidth / width
	            };
	        }
	    }, {
	        key: 'getMaxOffsets',
	        value: function getMaxOffsets() {
	            var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
	
	            var currentImageInfo = this.getBestImageForType('mainSrc');
	            if (currentImageInfo === null) {
	                return { maxX: 0, minX: 0, maxY: 0, minY: 0 };
	            }
	
	            var boxSize = this.getLightboxRect();
	            var zoomMultiplier = this.getZoomMultiplier(zoomLevel);
	
	            var maxX = 0;
	            if (zoomMultiplier * currentImageInfo.width - boxSize.width < 0) {
	                // if there is still blank space in the X dimension, don't limit except to the opposite edge
	                maxX = (boxSize.width - zoomMultiplier * currentImageInfo.width) / 2;
	            } else {
	                maxX = (zoomMultiplier * currentImageInfo.width - boxSize.width) / 2;
	            }
	
	            var maxY = 0;
	            if (zoomMultiplier * currentImageInfo.height - boxSize.height < 0) {
	                // if there is still blank space in the Y dimension, don't limit except to the opposite edge
	                maxY = (boxSize.height - zoomMultiplier * currentImageInfo.height) / 2;
	            } else {
	                maxY = (zoomMultiplier * currentImageInfo.height - boxSize.height) / 2;
	            }
	
	            return {
	                maxX: maxX,
	                maxY: maxY,
	                minX: -1 * maxX,
	                minY: -1 * maxY
	            };
	        }
	
	        // Get image src types
	
	    }, {
	        key: 'getSrcTypes',
	        value: function getSrcTypes() {
	            return [{
	                name: 'mainSrc',
	                keyEnding: 'i' + this.keyCounter
	            }, {
	                name: 'mainSrcThumbnail',
	                keyEnding: 't' + this.keyCounter
	            }, {
	                name: 'nextSrc',
	                keyEnding: 'i' + (this.keyCounter + 1)
	            }, {
	                name: 'nextSrcThumbnail',
	                keyEnding: 't' + (this.keyCounter + 1)
	            }, {
	                name: 'prevSrc',
	                keyEnding: 'i' + (this.keyCounter - 1)
	            }, {
	                name: 'prevSrcThumbnail',
	                keyEnding: 't' + (this.keyCounter - 1)
	            }];
	        }
	
	        /**
	         * Get sizing when the image is scaled
	         */
	
	    }, {
	        key: 'getZoomMultiplier',
	        value: function getZoomMultiplier() {
	            var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
	
	            return Math.pow(_constant.ZOOM_RATIO, zoomLevel);
	        }
	
	        /**
	         * Get the size of the lightbox in pixels
	         */
	
	    }, {
	        key: 'getLightboxRect',
	        value: function getLightboxRect() {
	            if (this.outerEl) {
	                return this.outerEl.getBoundingClientRect();
	            }
	
	            return {
	                width: (0, _util.getWindowWidth)(),
	                height: (0, _util.getWindowHeight)(),
	                top: 0,
	                right: 0,
	                bottom: 0,
	                left: 0
	            };
	        }
	
	        /**
	         * Handle user keyboard actions
	         */
	
	    }, {
	        key: 'handleKeyInput',
	        value: function handleKeyInput(event) {
	            event.stopPropagation();
	
	            // Ignore key input during animations
	            if (this.isAnimating()) {
	                return;
	            }
	
	            // Allow slightly faster navigation through the images when user presses keys repeatedly
	            if (event.type === 'keyup') {
	                this.lastKeyDownTime -= this.props.keyRepeatKeyupBonus;
	                return;
	            }
	
	            var keyCode = event.which || event.keyCode;
	
	            // Ignore key presses that happen too close to each other (when rapid fire key pressing or holding down the key)
	            // But allow it if it's a lightbox closing action
	            var currentTime = new Date();
	            if (currentTime.getTime() - this.lastKeyDownTime < this.props.keyRepeatLimit && keyCode !== _constant.KEYS.ESC) {
	                return;
	            }
	            this.lastKeyDownTime = currentTime.getTime();
	
	            switch (keyCode) {
	                // ESC key closes the lightbox
	                case _constant.KEYS.ESC:
	                    event.preventDefault();
	                    this.requestClose(event);
	                    break;
	
	                // Left arrow key moves to previous image
	                case _constant.KEYS.LEFT_ARROW:
	                    if (!this.props.prevSrc) {
	                        return;
	                    }
	
	                    event.preventDefault();
	                    this.keyPressed = true;
	                    this.requestMovePrev(event);
	                    break;
	
	                // Right arrow key moves to next image
	                case _constant.KEYS.RIGHT_ARROW:
	                    if (!this.props.nextSrc) {
	                        return;
	                    }
	
	                    event.preventDefault();
	                    this.keyPressed = true;
	                    this.requestMoveNext(event);
	                    break;
	
	                default:
	            }
	        }
	
	        /**
	         * Handle a mouse wheel event over the lightbox container
	         */
	
	    }, {
	        key: 'handleOuterMousewheel',
	        value: function handleOuterMousewheel(event) {
	            var _this5 = this;
	
	            // Prevent scrolling of the background
	            event.preventDefault();
	            event.stopPropagation();
	
	            var xThreshold = _constant.WHEEL_MOVE_X_THRESHOLD;
	            var actionDelay = 0;
	            var imageMoveDelay = 500;
	
	            this.clearTimeout(this.resetScrollTimeout);
	            this.resetScrollTimeout = this.setTimeout(function () {
	                _this5.scrollX = 0;
	                _this5.scrollY = 0;
	            }, 300);
	
	            // Prevent rapid-fire zoom behavior
	            if (this.wheelActionTimeout !== null || this.isAnimating()) {
	                return;
	            }
	
	            if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
	                // handle horizontal scrolls with image moves
	                this.scrollY = 0;
	                this.scrollX += event.deltaX;
	
	                var bigLeapX = xThreshold / 2;
	                // If the scroll amount has accumulated sufficiently, or a large leap was taken
	                if (this.scrollX >= xThreshold || event.deltaX >= bigLeapX) {
	                    // Scroll right moves to next
	                    this.requestMoveNext(event);
	                    actionDelay = imageMoveDelay;
	                    this.scrollX = 0;
	                } else if (this.scrollX <= -1 * xThreshold || event.deltaX <= -1 * bigLeapX) {
	                    // Scroll left moves to previous
	                    this.requestMovePrev(event);
	                    actionDelay = imageMoveDelay;
	                    this.scrollX = 0;
	                }
	            }
	
	            // Allow successive actions after the set delay
	            if (actionDelay !== 0) {
	                this.wheelActionTimeout = this.setTimeout(function () {
	                    _this5.wheelActionTimeout = null;
	                }, actionDelay);
	            }
	        }
	    }, {
	        key: 'handleImageMouseWheel',
	        value: function handleImageMouseWheel(event) {
	            event.preventDefault();
	            var yThreshold = _constant.WHEEL_MOVE_Y_THRESHOLD;
	
	            if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
	                event.stopPropagation();
	                // If the vertical scroll amount was large enough, perform a zoom
	                if (Math.abs(event.deltaY) < yThreshold) {
	                    return;
	                }
	
	                this.scrollX = 0;
	                this.scrollY += event.deltaY;
	
	                this.changeZoom(this.state.zoomLevel - event.deltaY, event.clientX, event.clientY);
	            }
	        }
	
	        /**
	         * Handle a double click on the current image
	         */
	
	    }, {
	        key: 'handleImageDoubleClick',
	        value: function handleImageDoubleClick(event) {
	            if (this.state.zoomLevel > _constant.MIN_ZOOM_LEVEL) {
	                // A double click when zoomed in zooms all the way out
	                this.changeZoom(_constant.MIN_ZOOM_LEVEL, event.clientX, event.clientY);
	            } else {
	                // A double click when zoomed all the way out zooms in
	                this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE, event.clientX, event.clientY);
	            }
	        }
	    }, {
	        key: 'shouldHandleEvent',
	        value: function shouldHandleEvent(source) {
	            if (this.eventsSource === source) {
	                return true;
	            }
	            if (this.eventsSource === _constant.SOURCE_ANY) {
	                this.eventsSource = source;
	                return true;
	            }
	            switch (source) {
	                case _constant.SOURCE_MOUSE:
	                    return false;
	                case _constant.SOURCE_TOUCH:
	                    this.eventsSource = _constant.SOURCE_TOUCH;
	                    this.filterPointersBySource();
	                    return true;
	                case _constant.SOURCE_POINTER:
	                    if (this.eventsSource === _constant.SOURCE_MOUSE) {
	                        this.eventsSource = _constant.SOURCE_POINTER;
	                        this.filterPointersBySource();
	                        return true;
	                    }
	                    return false;
	                default:
	                    return false;
	            }
	        }
	    }, {
	        key: 'addPointer',
	        value: function addPointer(pointer) {
	            this.pointerList.push(pointer);
	        }
	    }, {
	        key: 'removePointer',
	        value: function removePointer(pointer) {
	            this.pointerList = this.pointerList.filter(function (_ref) {
	                var id = _ref.id;
	                return id !== pointer.id;
	            });
	        }
	    }, {
	        key: 'filterPointersBySource',
	        value: function filterPointersBySource() {
	            var _this6 = this;
	
	            this.pointerList = this.pointerList.filter(function (_ref2) {
	                var source = _ref2.source;
	                return source === _this6.eventsSource;
	            });
	        }
	    }, {
	        key: 'handleMouseDown',
	        value: function handleMouseDown(event) {
	            if (this.shouldHandleEvent(_constant.SOURCE_MOUSE) && ReactImageLightbox.isTargetMatchImage(event.target)) {
	                this.addPointer(ReactImageLightbox.parseMouseEvent(event));
	                this.multiPointerStart(event);
	            }
	        }
	    }, {
	        key: 'handleMouseMove',
	        value: function handleMouseMove(event) {
	            if (this.shouldHandleEvent(_constant.SOURCE_MOUSE)) {
	                this.multiPointerMove(event, [ReactImageLightbox.parseMouseEvent(event)]);
	            }
	        }
	    }, {
	        key: 'handleMouseUp',
	        value: function handleMouseUp(event) {
	            if (this.shouldHandleEvent(_constant.SOURCE_MOUSE)) {
	                this.removePointer(ReactImageLightbox.parseMouseEvent(event));
	                this.multiPointerEnd(event);
	            }
	        }
	    }, {
	        key: 'handlePointerEvent',
	        value: function handlePointerEvent(event) {
	            if (this.shouldHandleEvent(_constant.SOURCE_POINTER)) {
	                switch (event.type) {
	                    case 'pointerdown':
	                        if (ReactImageLightbox.isTargetMatchImage(event.target)) {
	                            this.addPointer(ReactImageLightbox.parsePointerEvent(event));
	                            this.multiPointerStart(event);
	                        }
	                        break;
	                    case 'pointermove':
	                        this.multiPointerMove(event, [ReactImageLightbox.parsePointerEvent(event)]);
	                        break;
	                    case 'pointerup':
	                    case 'pointercancel':
	                        this.removePointer(ReactImageLightbox.parsePointerEvent(event));
	                        this.multiPointerEnd(event);
	                        break;
	                    default:
	                        break;
	                }
	            }
	        }
	    }, {
	        key: 'handleTouchStart',
	        value: function handleTouchStart(event) {
	            var _this7 = this;
	
	            if (this.shouldHandleEvent(_constant.SOURCE_TOUCH) && ReactImageLightbox.isTargetMatchImage(event.target)) {
	                [].forEach.call(event.changedTouches, function (eventTouch) {
	                    return _this7.addPointer(ReactImageLightbox.parseTouchPointer(eventTouch));
	                });
	                this.multiPointerStart(event);
	            }
	        }
	    }, {
	        key: 'handleTouchMove',
	        value: function handleTouchMove(event) {
	            if (this.shouldHandleEvent(_constant.SOURCE_TOUCH)) {
	                this.multiPointerMove(event, [].map.call(event.changedTouches, function (eventTouch) {
	                    return ReactImageLightbox.parseTouchPointer(eventTouch);
	                }));
	            }
	        }
	    }, {
	        key: 'handleTouchEnd',
	        value: function handleTouchEnd(event) {
	            var _this8 = this;
	
	            if (this.shouldHandleEvent(_constant.SOURCE_TOUCH)) {
	                [].map.call(event.changedTouches, function (touch) {
	                    return _this8.removePointer(ReactImageLightbox.parseTouchPointer(touch));
	                });
	                this.multiPointerEnd(event);
	            }
	        }
	    }, {
	        key: 'decideMoveOrSwipe',
	        value: function decideMoveOrSwipe(pointer) {
	            if (this.state.zoomLevel <= _constant.MIN_ZOOM_LEVEL) {
	                this.handleSwipeStart(pointer);
	            } else {
	                this.handleMoveStart(pointer);
	            }
	        }
	    }, {
	        key: 'multiPointerStart',
	        value: function multiPointerStart(event) {
	            this.handleEnd(null);
	            switch (this.pointerList.length) {
	                case 1:
	                    {
	                        event.preventDefault();
	                        this.decideMoveOrSwipe(this.pointerList[0]);
	                        break;
	                    }
	                case 2:
	                    {
	                        event.preventDefault();
	                        this.handlePinchStart(this.pointerList);
	                        break;
	                    }
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'multiPointerMove',
	        value: function multiPointerMove(event, pointerList) {
	            switch (this.currentAction) {
	                case _constant.ACTION_MOVE:
	                    {
	                        event.preventDefault();
	                        this.handleMove(pointerList[0]);
	                        break;
	                    }
	                case _constant.ACTION_SWIPE:
	                    {
	                        event.preventDefault();
	                        this.handleSwipe(pointerList[0]);
	                        break;
	                    }
	                case _constant.ACTION_PINCH:
	                    {
	                        event.preventDefault();
	                        this.handlePinch(pointerList);
	                        break;
	                    }
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'multiPointerEnd',
	        value: function multiPointerEnd(event) {
	            if (this.currentAction !== _constant.ACTION_NONE) {
	                this.setPreventInnerClose();
	                this.handleEnd(event);
	            }
	            switch (this.pointerList.length) {
	                case 0:
	                    {
	                        this.eventsSource = _constant.SOURCE_ANY;
	                        break;
	                    }
	                case 1:
	                    {
	                        event.preventDefault();
	                        this.decideMoveOrSwipe(this.pointerList[0]);
	                        break;
	                    }
	                case 2:
	                    {
	                        event.preventDefault();
	                        this.handlePinchStart(this.pointerList);
	                        break;
	                    }
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'handleEnd',
	        value: function handleEnd(event) {
	            switch (this.currentAction) {
	                case _constant.ACTION_MOVE:
	                    this.handleMoveEnd(event);
	                    break;
	                case _constant.ACTION_SWIPE:
	                    this.handleSwipeEnd(event);
	                    break;
	                case _constant.ACTION_PINCH:
	                    this.handlePinchEnd(event);
	                    break;
	                default:
	                    break;
	            }
	        }
	
	        // Handle move start over the lightbox container
	        // This happens:
	        // - On a mouseDown event
	        // - On a touchstart event
	
	    }, {
	        key: 'handleMoveStart',
	        value: function handleMoveStart(_ref3) {
	            var clientX = _ref3.x,
	                clientY = _ref3.y;
	
	            if (!this.props.enableZoom) {
	                return;
	            }
	            this.currentAction = _constant.ACTION_MOVE;
	            this.moveStartX = clientX;
	            this.moveStartY = clientY;
	            this.moveStartOffsetX = this.state.offsetX;
	            this.moveStartOffsetY = this.state.offsetY;
	        }
	
	        // Handle dragging over the lightbox container
	        // This happens:
	        // - After a mouseDown and before a mouseUp event
	        // - After a touchstart and before a touchend event
	
	    }, {
	        key: 'handleMove',
	        value: function handleMove(_ref4) {
	            var clientX = _ref4.x,
	                clientY = _ref4.y;
	
	            var newOffsetX = this.moveStartX - clientX + this.moveStartOffsetX;
	            var newOffsetY = this.moveStartY - clientY + this.moveStartOffsetY;
	            if (this.state.offsetX !== newOffsetX || this.state.offsetY !== newOffsetY) {
	                this.setState({
	                    offsetX: newOffsetX,
	                    offsetY: newOffsetY
	                });
	            }
	        }
	    }, {
	        key: 'handleMoveEnd',
	        value: function handleMoveEnd() {
	            var _this9 = this;
	
	            this.currentAction = _constant.ACTION_NONE;
	            this.moveStartX = 0;
	            this.moveStartY = 0;
	            this.moveStartOffsetX = 0;
	            this.moveStartOffsetY = 0;
	            // Snap image back into frame if outside max offset range
	            var maxOffsets = this.getMaxOffsets();
	            var nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, this.state.offsetX));
	            var nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, this.state.offsetY));
	            if (nextOffsetX !== this.state.offsetX || nextOffsetY !== this.state.offsetY) {
	                this.setState({
	                    offsetX: nextOffsetX,
	                    offsetY: nextOffsetY,
	                    shouldAnimate: true
	                });
	                this.setTimeout(function () {
	                    _this9.setState({ shouldAnimate: false });
	                }, this.props.animationDuration);
	            }
	        }
	    }, {
	        key: 'handleSwipeStart',
	        value: function handleSwipeStart(_ref5) {
	            var clientX = _ref5.x,
	                clientY = _ref5.y;
	
	            this.currentAction = _constant.ACTION_SWIPE;
	            this.swipeStartX = clientX;
	            this.swipeStartY = clientY;
	            this.swipeEndX = clientX;
	            this.swipeEndY = clientY;
	        }
	    }, {
	        key: 'handleSwipe',
	        value: function handleSwipe(_ref6) {
	            var clientX = _ref6.x,
	                clientY = _ref6.y;
	
	            this.swipeEndX = clientX;
	            this.swipeEndY = clientY;
	        }
	    }, {
	        key: 'handleSwipeEnd',
	        value: function handleSwipeEnd(event) {
	            var xDiff = this.swipeEndX - this.swipeStartX;
	            var xDiffAbs = Math.abs(xDiff);
	            var yDiffAbs = Math.abs(this.swipeEndY - this.swipeStartY);
	
	            this.currentAction = _constant.ACTION_NONE;
	            this.swipeStartX = 0;
	            this.swipeStartY = 0;
	            this.swipeEndX = 0;
	            this.swipeEndY = 0;
	
	            if (!event || this.isAnimating() || xDiffAbs < yDiffAbs * 1.5) {
	                return;
	            }
	
	            if (xDiffAbs < _constant.MIN_SWIPE_DISTANCE) {
	                var boxRect = this.getLightboxRect();
	                if (xDiffAbs < boxRect.width / 4) {
	                    return;
	                }
	            }
	
	            if (xDiff > 0 && this.props.prevSrc) {
	                event.preventDefault();
	                this.requestMovePrev();
	            } else if (xDiff < 0 && this.props.nextSrc) {
	                event.preventDefault();
	                this.requestMoveNext();
	            }
	        }
	    }, {
	        key: 'calculatePinchDistance',
	        value: function calculatePinchDistance() {
	            var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList,
	                _ref8 = _slicedToArray(_ref7, 2),
	                a = _ref8[0],
	                b = _ref8[1];
	
	            return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
	        }
	    }, {
	        key: 'calculatePinchCenter',
	        value: function calculatePinchCenter() {
	            var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList,
	                _ref10 = _slicedToArray(_ref9, 2),
	                a = _ref10[0],
	                b = _ref10[1];
	
	            return {
	                x: a.x - (a.x - b.x) / 2,
	                y: a.y - (a.y - b.y) / 2
	            };
	        }
	    }, {
	        key: 'handlePinchStart',
	        value: function handlePinchStart(pointerList) {
	            if (!this.props.enableZoom) {
	                return;
	            }
	            this.currentAction = _constant.ACTION_PINCH;
	            this.pinchTouchList = pointerList.map(function (_ref11) {
	                var id = _ref11.id,
	                    x = _ref11.x,
	                    y = _ref11.y;
	                return { id: id, x: x, y: y };
	            });
	            this.pinchDistance = this.calculatePinchDistance();
	        }
	    }, {
	        key: 'handlePinch',
	        value: function handlePinch(pointerList) {
	            this.pinchTouchList = this.pinchTouchList.map(function (oldPointer) {
	                for (var i = 0; i < pointerList.length; i++) {
	                    if (pointerList[i].id === oldPointer.id) {
	                        return pointerList[i];
	                    }
	                }
	
	                return oldPointer;
	            });
	
	            var newDistance = this.calculatePinchDistance();
	
	            // Propably this should be more complicated... but works fine?
	            var zoomLevel = this.state.zoomLevel + newDistance - this.pinchDistance;
	
	            this.pinchDistance = newDistance;
	
	            var _calculatePinchCenter = this.calculatePinchCenter(this.pinchTouchList),
	                clientX = _calculatePinchCenter.x,
	                clientY = _calculatePinchCenter.y;
	
	            this.changeZoom(zoomLevel, clientX, clientY);
	        }
	    }, {
	        key: 'handlePinchEnd',
	        value: function handlePinchEnd() {
	            this.currentAction = _constant.ACTION_NONE;
	            this.pinchTouchList = null;
	            this.pinchDistance = 0;
	        }
	
	        // Handle the window resize event
	
	    }, {
	        key: 'handleWindowResize',
	        value: function handleWindowResize() {
	            this.clearTimeout(this.resizeTimeout);
	            this.resizeTimeout = this.setTimeout(this.forceUpdate.bind(this), 100);
	        }
	    }, {
	        key: 'handleZoomInButtonClick',
	        value: function handleZoomInButtonClick() {
	            this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE);
	        }
	    }, {
	        key: 'handleZoomOutButtonClick',
	        value: function handleZoomOutButtonClick() {
	            this.changeZoom(this.state.zoomLevel - _constant.ZOOM_BUTTON_INCREMENT_SIZE);
	        }
	    }, {
	        key: 'handleCaptionMousewheel',
	        value: function handleCaptionMousewheel(event) {
	            event.stopPropagation();
	
	            if (!this.caption) {
	                return;
	            }
	
	            var height = this.caption.getBoundingClientRect().height;
	            var scrollHeight = this.caption.scrollHeight;
	            var scrollTop = this.caption.scrollTop;
	            if (event.deltaY > 0 && height + scrollTop >= scrollHeight || event.deltaY < 0 && scrollTop <= 0) {
	                event.preventDefault();
	            }
	        }
	
	        // Detach key and mouse input events
	
	    }, {
	        key: 'isAnimating',
	        value: function isAnimating() {
	            return this.state.shouldAnimate || this.state.isClosing;
	        }
	
	        // Check if image is loaded
	
	    }, {
	        key: 'isImageLoaded',
	        value: function isImageLoaded(imageSrc) {
	            return imageSrc && imageSrc in this.imageCache && this.imageCache[imageSrc].loaded;
	        }
	
	        // Load image from src and call callback with image width and height on load
	
	    }, {
	        key: 'loadImage',
	        value: function loadImage(srcType, imageSrc, done) {
	            var _this10 = this;
	
	            // Return the image info if it is already cached
	            if (this.isImageLoaded(imageSrc)) {
	                this.setTimeout(function () {
	                    done();
	                }, 1);
	                return;
	            }
	
	            var that = this;
	            var inMemoryImage = new Image();
	
	            inMemoryImage.onerror = function (errorEvent) {
	                _this10.props.onImageLoadError(imageSrc, srcType, errorEvent);
	                done(errorEvent);
	            };
	
	            inMemoryImage.onload = function onLoad() {
	                that.imageCache[imageSrc] = {
	                    loaded: true,
	                    width: this.width,
	                    height: this.height
	                };
	
	                done();
	            };
	
	            inMemoryImage.src = imageSrc;
	        }
	
	        // Load all images and their thumbnails
	
	    }, {
	        key: 'loadAllImages',
	        value: function loadAllImages() {
	            var _this11 = this;
	
	            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	            var generateLoadDoneCallback = function generateLoadDoneCallback(srcType, imageSrc) {
	                return function (err) {
	                    // Give up showing image on error
	                    if (err) {
	                        return;
	                    }
	
	                    // Don't rerender if the src is not the same as when the load started
	                    // or if the component has unmounted
	                    if (_this11.props[srcType] !== imageSrc || !_this11.mounted) {
	                        return;
	                    }
	
	                    // Force rerender with the new image
	                    _this11.forceUpdate();
	                };
	            };
	
	            // Load the images
	            this.getSrcTypes().forEach(function (srcType) {
	                var type = srcType.name;
	
	                // Load unloaded images
	                if (props[type] && !_this11.isImageLoaded(props[type])) {
	                    _this11.loadImage(type, props[type], generateLoadDoneCallback(type, props[type]));
	                }
	            });
	        }
	
	        // Request that the lightbox be closed
	
	    }, {
	        key: 'requestClose',
	        value: function requestClose(event) {
	            var _this12 = this;
	
	            // Call the parent close request
	            var closeLightbox = function closeLightbox() {
	                return _this12.props.onCloseRequest(event);
	            };
	
	            if (this.props.animationDisabled || event.type === 'keydown' && !this.props.animationOnKeyInput) {
	                // No animation
	                return closeLightbox();
	            }
	
	            // With animation
	            // Start closing animation
	            this.setState({ isClosing: true });
	
	            // Perform the actual closing at the end of the animation
	            this.setTimeout(closeLightbox, this.props.animationDuration);
	        }
	    }, {
	        key: 'requestMove',
	        value: function requestMove(direction, event) {
	            var _this13 = this;
	
	            // Reset the zoom level on image move
	            var nextState = {
	                zoomLevel: _constant.MIN_ZOOM_LEVEL,
	                offsetX: 0,
	                offsetY: 0
	            };
	
	            // Enable animated states
	            if (!this.props.animationDisabled && (!this.keyPressed || this.props.animationOnKeyInput)) {
	                nextState.shouldAnimate = true;
	                this.setTimeout(function () {
	                    return _this13.setState({ shouldAnimate: false });
	                }, this.props.animationDuration);
	            }
	            this.keyPressed = false;
	
	            this.moveRequested = true;
	
	            if (direction === 'prev') {
	                this.keyCounter--;
	                this.setState(nextState);
	                this.props.onMovePrevRequest(event);
	            } else {
	                this.keyCounter++;
	                this.setState(nextState);
	                this.props.onMoveNextRequest(event);
	            }
	        }
	
	        // Request to transition to the next image
	
	    }, {
	        key: 'requestMoveNext',
	        value: function requestMoveNext(event) {
	            this.requestMove('next', event);
	        }
	
	        // Request to transition to the previous image
	
	    }, {
	        key: 'requestMovePrev',
	        value: function requestMovePrev(event) {
	            this.requestMove('prev', event);
	        }
	
	        // Request to transition to the previous image
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this14 = this;
	
	            var _props = this.props,
	                animationDisabled = _props.animationDisabled,
	                animationDuration = _props.animationDuration,
	                clickOutsideToClose = _props.clickOutsideToClose,
	                discourageDownloads = _props.discourageDownloads,
	                enableZoom = _props.enableZoom,
	                imageTitle = _props.imageTitle,
	                nextSrc = _props.nextSrc,
	                prevSrc = _props.prevSrc,
	                toolbarButtons = _props.toolbarButtons,
	                reactModalStyle = _props.reactModalStyle;
	            var _state = this.state,
	                zoomLevel = _state.zoomLevel,
	                offsetX = _state.offsetX,
	                offsetY = _state.offsetY,
	                isClosing = _state.isClosing;
	
	
	            var boxSize = this.getLightboxRect();
	            var transitionStyle = {};
	
	            // Transition settings for sliding animations
	            if (!animationDisabled && this.isAnimating()) {
	                transitionStyle = _extends({}, transitionStyle, {
	                    transition: 'transform ' + animationDuration + 'ms'
	                });
	            }
	
	            // Key endings to differentiate between images with the same src
	            var keyEndings = {};
	            this.getSrcTypes().forEach(function (_ref12) {
	                var name = _ref12.name,
	                    keyEnding = _ref12.keyEnding;
	
	                keyEndings[name] = keyEnding;
	            });
	
	            // Images to be displayed
	            var images = [];
	            var addImage = function addImage(srcType, imageClass) {
	                var baseStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	                // Ignore types that have no source defined for their full size image
	                if (!_this14.props[srcType]) {
	                    return;
	                }
	
	                var imageStyle = _extends({}, baseStyle, transitionStyle);
	                if (zoomLevel > _constant.MIN_ZOOM_LEVEL) {
	                    imageStyle.cursor = 'move';
	                }
	
	                var bestImageInfo = _this14.getBestImageForType(srcType);
	                if (bestImageInfo === null) {
	                    var loadingIcon = void 0;
	                    if (_ieVersion < 10) {
	                        loadingIcon = _react2.default.createElement(
	                            'div',
	                            { className: styles.loadingContainer__icon },
	                            (0, _util.translate)('Loading...')
	                        );
	                    } else {
	                        loadingIcon = _react2.default.createElement(
	                            'div',
	                            { className: 'ril-loading-circle ' + styles.loadingCircle + ' ' + styles.loadingContainer__icon },
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint }),
	                            _react2.default.createElement('div', { className: 'ril-loading-circle-point ' + styles.loadingCirclePoint })
	                        );
	                    }
	
	                    // Fall back to loading icon if the thumbnail has not been loaded
	                    images.push(_react2.default.createElement(
	                        'div',
	                        {
	                            className: imageClass + ' ' + styles.image + ' not-loaded ril-not-loaded',
	                            style: imageStyle,
	                            key: _this14.props[srcType] + keyEndings[srcType]
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: styles.loadingContainer },
	                            loadingIcon
	                        )
	                    ));
	
	                    return;
	                }
	
	                imageStyle.width = bestImageInfo.width;
	                imageStyle.height = bestImageInfo.height;
	
	                var imageSrc = bestImageInfo.src;
	                if (discourageDownloads) {
	                    imageStyle.backgroundImage = 'url(\'' + imageSrc + '\')';
	                    images.push(_react2.default.createElement(
	                        'div',
	                        {
	                            className: imageClass + ' ' + styles.image + ' ' + styles.imageDiscourager,
	                            onDoubleClick: _this14.handleImageDoubleClick,
	                            onWheel: _this14.handleImageMouseWheel,
	                            style: imageStyle,
	                            key: imageSrc + keyEndings[srcType]
	                        },
	                        _react2.default.createElement('div', { className: 'download-blocker ril-download-blocker ' + styles.downloadBlocker })
	                    ));
	                } else {
	                    images.push(_react2.default.createElement('img', {
	                        className: imageClass + ' ' + styles.image,
	                        onDoubleClick: _this14.handleImageDoubleClick,
	                        onWheel: _this14.handleImageMouseWheel,
	                        onDragStart: function onDragStart(e) {
	                            return e.preventDefault();
	                        },
	                        style: imageStyle,
	                        src: imageSrc,
	                        key: imageSrc + keyEndings[srcType],
	                        alt: typeof imageTitle === 'string' ? imageTitle : (0, _util.translate)('Image'),
	                        draggable: false
	                    }));
	                }
	            };
	
	            var zoomMultiplier = this.getZoomMultiplier();
	            // Next Image (displayed on the right)
	            addImage('nextSrc', 'image-next ril-image-next ' + styles.imageNext, ReactImageLightbox.getTransform({ x: boxSize.width }));
	            // Main Image
	            addImage('mainSrc', 'image-current ril-image-current', ReactImageLightbox.getTransform({
	                x: -1 * offsetX,
	                y: -1 * offsetY,
	                zoom: zoomMultiplier
	            }));
	            // Previous Image (displayed on the left)
	            addImage('prevSrc', 'image-prev ril-image-prev ' + styles.imagePrev, ReactImageLightbox.getTransform({ x: -1 * boxSize.width }));
	
	            var noop = function noop() {};
	
	            // Prepare styles and handlers for the zoom in/out buttons
	            var zoomInButtonClasses = [styles.toolbarItemChild, styles.builtinButton, styles.zoomInButton];
	            var zoomOutButtonClasses = [styles.toolbarItemChild, styles.builtinButton, styles.zoomOutButton];
	            var zoomInButtonHandler = this.handleZoomInButtonClick;
	            var zoomOutButtonHandler = this.handleZoomOutButtonClick;
	
	            // Disable zooming in when zoomed all the way in
	            if (zoomLevel === _constant.MAX_ZOOM_LEVEL) {
	                zoomInButtonClasses.push(styles.builtinButtonDisabled);
	                zoomInButtonHandler = noop;
	            }
	
	            // Disable zooming out when zoomed all the way out
	            if (zoomLevel === _constant.MIN_ZOOM_LEVEL) {
	                zoomOutButtonClasses.push(styles.builtinButtonDisabled);
	                zoomOutButtonHandler = noop;
	            }
	
	            // Ignore clicks during animation
	            if (this.isAnimating()) {
	                zoomInButtonHandler = noop;
	                zoomOutButtonHandler = noop;
	            }
	
	            var modalStyle = {
	                overlay: _extends({
	                    zIndex: 1000,
	                    backgroundColor: 'transparent'
	                }, reactModalStyle.overlay),
	                content: _extends({
	                    backgroundColor: 'transparent',
	                    overflow: 'hidden', // Needed, otherwise keyboard shortcuts scroll the page
	                    border: 'none',
	                    borderRadius: 0,
	                    padding: 0,
	                    top: 0,
	                    left: 0,
	                    right: 0,
	                    bottom: 0
	                }, reactModalStyle.content)
	            };
	
	            // DEPRECATION NOTICE
	            // All unprefixed classes (listed below) will be removed in v4.0.0.
	            // Use their `ril-` prefixed alternatives instead.
	            //
	            // DEPRECATED: close, closing, download-blocker, image-current,
	            //             image-next, image-prev, inner, next-button, not-loaded,
	            //             outer, prev-button, toolbar, toolbar-left, toolbar-right,
	            //             zoom-in, zoom-out
	
	            return _react2.default.createElement(
	                _reactModal2.default,
	                {
	                    isOpen: true,
	                    onRequestClose: clickOutsideToClose ? this.requestClose : noop,
	                    onAfterOpen: function onAfterOpen() {
	                        return _this14.outerEl && _this14.outerEl.focus();
	                    } // Focus on the div with key handlers
	                    , style: modalStyle,
	                    contentLabel: (0, _util.translate)('Lightbox')
	                },
	                _react2.default.createElement(
	                    'div',
	                    { // eslint-disable-line jsx-a11y/no-static-element-interactions
	                        // Floating modal with closing animations
	                        className: 'outer ril-outer ' + styles.outer + ' ' + styles.outerAnimating + (isClosing ? ' closing ril-closing ' + styles.outerClosing : ''),
	                        style: {
	                            transition: 'opacity ' + animationDuration + 'ms',
	                            animationDuration: animationDuration + 'ms',
	                            animationDirection: isClosing ? 'normal' : 'reverse'
	                        },
	                        ref: function ref(el) {
	                            _this14.outerEl = el;
	                        },
	                        onWheel: this.handleOuterMousewheel,
	                        onMouseMove: this.handleMouseMove,
	                        onMouseDown: this.handleMouseDown,
	                        onTouchStart: this.handleTouchStart,
	                        onTouchMove: this.handleTouchMove,
	                        tabIndex: '-1' // Enables key handlers on div
	                        , onKeyDown: this.handleKeyInput,
	                        onKeyUp: this.handleKeyInput
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { // eslint-disable-line jsx-a11y/no-static-element-interactions
	                            // Image holder
	                            className: 'inner ril-inner ' + styles.inner,
	                            onClick: clickOutsideToClose ? this.closeIfClickInner : noop
	                        },
	                        images
	                    ),
	                    prevSrc && _react2.default.createElement('button', { // Move to previous image button
	                        type: 'button',
	                        className: 'prev-button ril-prev-button ' + styles.navButtons + ' ' + styles.navButtonPrev,
	                        key: 'prev',
	                        onClick: !this.isAnimating() ? this.requestMovePrev : noop // Ignore clicks during animation
	                    }),
	                    nextSrc && _react2.default.createElement('button', { // Move to next image button
	                        type: 'button',
	                        className: 'next-button ril-next-button ' + styles.navButtons + ' ' + styles.navButtonNext,
	                        key: 'next',
	                        onClick: !this.isAnimating() ? this.requestMoveNext : noop // Ignore clicks during animation
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { // Lightbox toolbar
	                            className: 'toolbar ril-toolbar ' + styles.toolbar
	                        },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'toolbar-left ril-toolbar-left ' + styles.toolbarSide + ' ' + styles.toolbarLeftSide },
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'ril-toolbar__item ' + styles.toolbarItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'ril-toolbar__item__child ' + styles.toolbarItemChild },
	                                    imageTitle
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            {
	                                className: ['toolbar-right', 'ril-toolbar-right', styles.toolbarSide, styles.toolbarRightSide].join(' ')
	                            },
	                            !toolbarButtons ? '' : toolbarButtons.map(function (button, i) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: i, className: 'ril-toolbar__item ' + styles.toolbarItem },
	                                    button
	                                );
	                            }),
	                            enableZoom && _react2.default.createElement(
	                                'li',
	                                { className: 'ril-toolbar__item ' + styles.toolbarItem },
	                                _react2.default.createElement('button', { // Lightbox zoom in button
	                                    type: 'button',
	                                    key: 'zoom-in',
	                                    className: 'zoom-in ril-zoom-in ' + zoomInButtonClasses.join(' '),
	                                    onClick: zoomInButtonHandler
	                                })
	                            ),
	                            enableZoom && _react2.default.createElement(
	                                'li',
	                                { className: 'ril-toolbar__item ' + styles.toolbarItem },
	                                _react2.default.createElement('button', { // Lightbox zoom out button
	                                    type: 'button',
	                                    key: 'zoom-out',
	                                    className: 'zoom-out ril-zoom-out ' + zoomOutButtonClasses.join(' '),
	                                    onClick: zoomOutButtonHandler
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'ril-toolbar__item ' + styles.toolbarItem },
	                                _react2.default.createElement('button', { // Lightbox close button
	                                    type: 'button',
	                                    key: 'close',
	                                    className: 'close ril-close ril-toolbar__item__child' + (' ' + styles.toolbarItemChild + ' ' + styles.builtinButton + ' ' + styles.closeButton),
	                                    onClick: !this.isAnimating() ? this.requestClose : noop // Ignore clicks during animation
	                                })
	                            )
	                        )
	                    ),
	                    this.props.imageCaption && _react2.default.createElement(
	                        'div',
	                        { // Image caption
	                            onWheel: this.handleCaptionMousewheel,
	                            onMouseDown: function onMouseDown(event) {
	                                return event.stopPropagation();
	                            },
	                            className: 'ril-caption ' + styles.caption,
	                            ref: function ref(el) {
	                                _this14.caption = el;
	                            }
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'ril-caption-content ' + styles.captionContent
	                            },
	                            this.props.imageCaption
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'isTargetMatchImage',
	        value: function isTargetMatchImage(target) {
	            return target && /ril-image-current/.test(target.className);
	        }
	    }, {
	        key: 'parseMouseEvent',
	        value: function parseMouseEvent(mouseEvent) {
	            return {
	                id: 'mouse',
	                source: _constant.SOURCE_MOUSE,
	                x: parseInt(mouseEvent.clientX, 10),
	                y: parseInt(mouseEvent.clientY, 10)
	            };
	        }
	    }, {
	        key: 'parseTouchPointer',
	        value: function parseTouchPointer(touchPointer) {
	            return {
	                id: touchPointer.identifier,
	                source: _constant.SOURCE_TOUCH,
	                x: parseInt(touchPointer.clientX, 10),
	                y: parseInt(touchPointer.clientY, 10)
	            };
	        }
	    }, {
	        key: 'parsePointerEvent',
	        value: function parsePointerEvent(pointerEvent) {
	            return {
	                id: pointerEvent.pointerId,
	                source: _constant.SOURCE_POINTER,
	                x: parseInt(pointerEvent.clientX, 10),
	                y: parseInt(pointerEvent.clientY, 10)
	            };
	        }
	    }, {
	        key: 'getTransform',
	        value: function getTransform(_ref13) {
	            var _ref13$x = _ref13.x,
	                x = _ref13$x === undefined ? null : _ref13$x,
	                _ref13$y = _ref13.y,
	                y = _ref13$y === undefined ? null : _ref13$y,
	                _ref13$zoom = _ref13.zoom,
	                zoom = _ref13$zoom === undefined ? null : _ref13$zoom;
	
	            var isOldIE = _ieVersion < 10;
	            var transforms = [];
	            if (x !== null || y !== null) {
	                transforms.push(isOldIE ? 'translate(' + (x || 0) + 'px,' + (y || 0) + 'px)' : 'translate3d(' + (x || 0) + 'px,' + (y || 0) + 'px,0)');
	            }
	
	            if (zoom !== null) {
	                transforms.push(isOldIE ? 'scale(' + zoom + ')' : 'scale3d(' + zoom + ',' + zoom + ',1)');
	            }
	
	            return _defineProperty({}, isOldIE ? 'msTransform' : 'transform', transforms.length === 0 ? 'none' : transforms.join(' '));
	        }
	    }, {
	        key: 'loadStyles',
	        value: function loadStyles() {
	            // Insert component styles
	            if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
	                styles._insertCss();
	            }
	        }
	    }]);
	
	    return ReactImageLightbox;
	}(_react.Component);
	
	ReactImageLightbox.propTypes = {
	    //-----------------------------
	    // Image sources
	    //-----------------------------
	
	    // Main display image url
	    mainSrc: _propTypes2.default.string.isRequired, // eslint-disable-line react/no-unused-prop-types
	
	    // Previous display image url (displayed to the left)
	    // If left undefined, movePrev actions will not be performed, and the button not displayed
	    prevSrc: _propTypes2.default.string,
	
	    // Next display image url (displayed to the right)
	    // If left undefined, moveNext actions will not be performed, and the button not displayed
	    nextSrc: _propTypes2.default.string,
	
	    //-----------------------------
	    // Image thumbnail sources
	    //-----------------------------
	
	    // Thumbnail image url corresponding to props.mainSrc
	    mainSrcThumbnail: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
	
	    // Thumbnail image url corresponding to props.prevSrc
	    prevSrcThumbnail: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
	
	    // Thumbnail image url corresponding to props.nextSrc
	    nextSrcThumbnail: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
	
	    //-----------------------------
	    // Event Handlers
	    //-----------------------------
	
	    // Close window event
	    // Should change the parent state such that the lightbox is not rendered
	    onCloseRequest: _propTypes2.default.func.isRequired,
	
	    // Move to previous image event
	    // Should change the parent state such that props.prevSrc becomes props.mainSrc,
	    //  props.mainSrc becomes props.nextSrc, etc.
	    onMovePrevRequest: _propTypes2.default.func,
	
	    // Move to next image event
	    // Should change the parent state such that props.nextSrc becomes props.mainSrc,
	    //  props.mainSrc becomes props.prevSrc, etc.
	    onMoveNextRequest: _propTypes2.default.func,
	
	    // Called when an image fails to load
	    // (imageSrc: string, srcType: string, errorEvent: object): void
	    onImageLoadError: _propTypes2.default.func,
	
	    //-----------------------------
	    // Download discouragement settings
	    //-----------------------------
	
	    // Enable download discouragement (prevents [right-click -> Save Image As...])
	    discourageDownloads: _propTypes2.default.bool,
	
	    //-----------------------------
	    // Animation settings
	    //-----------------------------
	
	    // Disable all animation
	    animationDisabled: _propTypes2.default.bool,
	
	    // Disable animation on actions performed with keyboard shortcuts
	    animationOnKeyInput: _propTypes2.default.bool,
	
	    // Animation duration (ms)
	    animationDuration: _propTypes2.default.number,
	
	    //-----------------------------
	    // Keyboard shortcut settings
	    //-----------------------------
	
	    // Required interval of time (ms) between key actions
	    // (prevents excessively fast navigation of images)
	    keyRepeatLimit: _propTypes2.default.number,
	
	    // Amount of time (ms) restored after each keyup
	    // (makes rapid key presses slightly faster than holding down the key to navigate images)
	    keyRepeatKeyupBonus: _propTypes2.default.number,
	
	    //-----------------------------
	    // Image info
	    //-----------------------------
	
	    // Image title
	    imageTitle: _propTypes2.default.node,
	
	    // Image caption
	    imageCaption: _propTypes2.default.node,
	
	    //-----------------------------
	    // Lightbox style
	    //-----------------------------
	
	    // Set z-index style, etc., for the parent react-modal (format: https://github.com/reactjs/react-modal#styles )
	    reactModalStyle: _propTypes2.default.object,
	
	    // Padding (px) between the edge of the window and the lightbox
	    imagePadding: _propTypes2.default.number,
	
	    //-----------------------------
	    // Other
	    //-----------------------------
	
	    // Array of custom toolbar buttons
	    toolbarButtons: _propTypes2.default.arrayOf(_propTypes2.default.node),
	
	    // When true, clicks outside of the image close the lightbox
	    clickOutsideToClose: _propTypes2.default.bool,
	
	    // Set to false to disable zoom functionality and hide zoom buttons
	    enableZoom: _propTypes2.default.bool
	};
	
	ReactImageLightbox.defaultProps = {
	    onMovePrevRequest: function onMovePrevRequest() {},
	    onMoveNextRequest: function onMoveNextRequest() {},
	    onImageLoadError: function onImageLoadError() {},
	
	    discourageDownloads: false,
	
	    animationDisabled: false,
	    animationOnKeyInput: false,
	    animationDuration: 300,
	
	    keyRepeatLimit: 180,
	    keyRepeatKeyupBonus: 40,
	
	    reactModalStyle: {},
	    imagePadding: 10,
	    clickOutsideToClose: true,
	    enableZoom: true
	};
	
	exports.default = ReactImageLightbox;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getIEVersion = getIEVersion;
	exports.translate = translate;
	exports.getWindowWidth = getWindowWidth;
	exports.getWindowHeight = getWindowHeight;
	exports.isInSameOriginIframe = isInSameOriginIframe;
	/**
	 * Get the version of Internet Explorer in use, or undefined
	 *
	 * @return {?number} ieVersion - IE version as an integer, or undefined if not IE
	 */
	function getIEVersion() {
	    if (typeof window === 'undefined') {
	        return undefined;
	    }
	
	    var match = window.navigator.userAgent.match(/(?:MSIE |Trident\/.*; rv:)(\d+)/);
	    return match ? parseInt(match[1], 10) : undefined;
	}
	
	/**
	 * Placeholder for future translate functionality
	 */
	function translate(str) {
	    var replaceStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    if (!str) {
	        return '';
	    }
	
	    var translated = str;
	    if (replaceStrings) {
	        Object.keys(replaceStrings).forEach(function (placeholder) {
	            translated = translated.replace(placeholder, replaceStrings[placeholder]);
	        });
	    }
	
	    return translated;
	}
	
	function getWindowWidth() {
	    if (typeof window === 'undefined') {
	        return 0;
	    }
	
	    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	}
	
	function getWindowHeight() {
	    if (typeof window === 'undefined') {
	        return 0;
	    }
	
	    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	}
	
	// Returns true if this window is rendered as an iframe inside another window
	// with the same origin.
	function isInSameOriginIframe() {
	    try {
	        return window.self !== window.top && window.top.document;
	    } catch (e) {
	        return false;
	    }
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(34), __esModule: true };

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(35), __esModule: true };

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(36), __esModule: true };

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(31);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(30);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(26);
	__webpack_require__(25);
	module.exports = __webpack_require__(60);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(26);
	__webpack_require__(25);
	module.exports = __webpack_require__(61);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var core  = __webpack_require__(3)
	  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(14)
	  , toLength  = __webpack_require__(56)
	  , toIndex   = __webpack_require__(55);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(37);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(2)
	  , core      = __webpack_require__(3)
	  , ctx       = __webpack_require__(40)
	  , hide      = __webpack_require__(4)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2).document && document.documentElement;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(7) && !__webpack_require__(19)(function(){
	  return Object.defineProperty(__webpack_require__(17)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(16);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(48)
	  , descriptor     = __webpack_require__(21)
	  , setToStringTag = __webpack_require__(22)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(4)(IteratorPrototype, __webpack_require__(1)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = true;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(6)
	  , dPs         = __webpack_require__(49)
	  , enumBugKeys = __webpack_require__(18)
	  , IE_PROTO    = __webpack_require__(12)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(17)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(42).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(11)
	  , anObject = __webpack_require__(6)
	  , getKeys  = __webpack_require__(52);
	
	module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(8)
	  , toObject    = __webpack_require__(57)
	  , IE_PROTO    = __webpack_require__(12)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(8)
	  , toIObject    = __webpack_require__(14)
	  , arrayIndexOf = __webpack_require__(39)(false)
	  , IE_PROTO     = __webpack_require__(12)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(51)
	  , enumBugKeys = __webpack_require__(18);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(13)
	  , defined   = __webpack_require__(9);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(13)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(13)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(9);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(10);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(15)
	  , ITERATOR  = __webpack_require__(1)('iterator')
	  , Iterators = __webpack_require__(5);
	module.exports = __webpack_require__(3).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(6)
	  , get      = __webpack_require__(59);
	module.exports = __webpack_require__(3).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(15)
	  , ITERATOR  = __webpack_require__(1)('iterator')
	  , Iterators = __webpack_require__(5);
	module.exports = __webpack_require__(3).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(38)
	  , step             = __webpack_require__(46)
	  , Iterators        = __webpack_require__(5)
	  , toIObject        = __webpack_require__(14);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(20)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(64)();
	// imports
	
	
	// module
	exports.push([module.id, "@-webkit-keyframes closeWindow___2Hlon{0%{opacity:1}to{opacity:0}}@keyframes closeWindow___2Hlon{0%{opacity:1}to{opacity:0}}.outer___2lDXy{background-color:rgba(0,0,0,.85);top:0;left:0;right:0;bottom:0;z-index:1000;width:100%;height:100%;-ms-content-zooming:none;-ms-user-select:none;-ms-touch-select:none;-ms-touch-action:none;touch-action:none}.outerClosing___1EQGK{opacity:0}.image___2FLq2,.inner___1rfRQ{position:absolute;top:0;left:0;right:0;bottom:0}.image___2FLq2{margin:auto;max-width:100%;max-height:100%;-ms-content-zooming:none;-ms-user-select:none;-ms-touch-select:none;-ms-touch-action:none;touch-action:none}.imageNext___1uRqJ,.imagePrev___F6xVQ{@extends .image}.imageDiscourager___3-CUB{background-repeat:no-repeat;background-position:50%;background-size:contain}.navButtons___3kNVF{border:none;position:absolute;top:0;bottom:0;width:20px;height:34px;padding:40px 30px;margin:auto;cursor:pointer;opacity:.7}.navButtons___3kNVF:hover{opacity:1}.navButtons___3kNVF:active{opacity:.7}.navButtonPrev___2vBS8{left:0;background:rgba(0,0,0,.2) url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDE5LDMgLTIsLTIgLTE2LDE2IDE2LDE2IDEsLTEgLTE1LC0xNSAxNSwtMTUgeiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==\") no-repeat 50%}.navButtonNext___30R2i{right:0;background:rgba(0,0,0,.2) url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDEsMyAyLC0yIDE2LDE2IC0xNiwxNiAtMSwtMSAxNSwtMTUgLTE1LC0xNSB6IiBmaWxsPSIjRkZGIi8+PC9zdmc+\") no-repeat 50%}.downloadBlocker___3rU9-{position:absolute;top:0;left:0;right:0;bottom:0;background-image:url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\");background-size:cover}.caption___3vDh_,.toolbar___1xYly{background-color:rgba(0,0,0,.5);position:absolute;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.caption___3vDh_{bottom:0;max-height:150px;overflow:auto}.captionContent___30kw2{padding:10px 20px;color:#fff}.toolbar___1xYly{top:0;height:50px}.toolbarSide___3FYWk{height:50px;margin:0}.toolbarSideNoFlex___KxqgW{height:auto;line-height:50px;max-width:48%;position:absolute;top:0;bottom:0}.toolbarLeftSide___8beAg{padding-left:20px;padding-right:0;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;overflow:hidden;text-overflow:ellipsis}.toolbarLeftSideNoFlex___3O3cZ{left:0;overflow:visible}.toolbarRightSide___1Sdfc{padding-left:0;padding-right:20px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.toolbarRightSideNoFlex___oa0FT{right:0}.toolbarItem___3WbMb{display:inline-block;line-height:50px;padding:0;color:#fff;font-size:120%;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.toolbarItemChild___2U_MP{vertical-align:middle}.builtinButton___1zqo6{width:40px;height:35px;cursor:pointer;border:none;opacity:.7}.builtinButton___1zqo6:hover{opacity:1}.builtinButton___1zqo6:active{outline:none}.builtinButtonDisabled___3uvqe{cursor:default;opacity:.5}.builtinButtonDisabled___3uvqe:hover{opacity:.5}.closeButton___3BdAF{background:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=\") no-repeat 50%}.zoomInButton___3xtuX{background:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PHBhdGggZD0iTTEyIDV2NiIvPjwvZz48Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+\") no-repeat 50%}.zoomOutButton___38PZx{background:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=\") no-repeat 50%}.outerAnimating___2-fZi{-webkit-animation-name:closeWindow___2Hlon;animation-name:closeWindow___2Hlon}@-webkit-keyframes pointFade___2RA5J{0%,19.999%,to{opacity:0}20%{opacity:1}}@keyframes pointFade___2RA5J{0%,19.999%,to{opacity:0}20%{opacity:1}}.loadingCircle___3JNJg{width:60px;height:60px;position:relative}.loadingCirclePoint___3md-S{width:100%;height:100%;position:absolute;left:0;top:0}.loadingCirclePoint___3md-S:before{content:\"\";display:block;margin:0 auto;width:15%;height:15%;background-color:#fff;border-radius:30%;-webkit-animation:pointFade___2RA5J 1.2s infinite ease-in-out both;animation:pointFade___2RA5J 1.2s infinite ease-in-out both}.loadingCirclePoint___3md-S:first-of-type{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg)}.loadingCirclePoint___3md-S:first-of-type:before,.loadingCirclePoint___3md-S:nth-of-type(7):before{-webkit-animation-delay:-1.2s;animation-delay:-1.2s}.loadingCirclePoint___3md-S:nth-of-type(2){-webkit-transform:rotate(30deg);-ms-transform:rotate(30deg);transform:rotate(30deg)}.loadingCirclePoint___3md-S:nth-of-type(8){-webkit-transform:rotate(210deg);-ms-transform:rotate(210deg);transform:rotate(210deg)}.loadingCirclePoint___3md-S:nth-of-type(2):before,.loadingCirclePoint___3md-S:nth-of-type(8):before{-webkit-animation-delay:-1s;animation-delay:-1s}.loadingCirclePoint___3md-S:nth-of-type(3){-webkit-transform:rotate(60deg);-ms-transform:rotate(60deg);transform:rotate(60deg)}.loadingCirclePoint___3md-S:nth-of-type(9){-webkit-transform:rotate(240deg);-ms-transform:rotate(240deg);transform:rotate(240deg)}.loadingCirclePoint___3md-S:nth-of-type(3):before,.loadingCirclePoint___3md-S:nth-of-type(9):before{-webkit-animation-delay:-.8s;animation-delay:-.8s}.loadingCirclePoint___3md-S:nth-of-type(4){-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.loadingCirclePoint___3md-S:nth-of-type(10){-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.loadingCirclePoint___3md-S:nth-of-type(4):before,.loadingCirclePoint___3md-S:nth-of-type(10):before{-webkit-animation-delay:-.6s;animation-delay:-.6s}.loadingCirclePoint___3md-S:nth-of-type(5){-webkit-transform:rotate(120deg);-ms-transform:rotate(120deg);transform:rotate(120deg)}.loadingCirclePoint___3md-S:nth-of-type(11){-webkit-transform:rotate(300deg);-ms-transform:rotate(300deg);transform:rotate(300deg)}.loadingCirclePoint___3md-S:nth-of-type(5):before,.loadingCirclePoint___3md-S:nth-of-type(11):before{-webkit-animation-delay:-.4s;animation-delay:-.4s}.loadingCirclePoint___3md-S:nth-of-type(6){-webkit-transform:rotate(150deg);-ms-transform:rotate(150deg);transform:rotate(150deg)}.loadingCirclePoint___3md-S:nth-of-type(12){-webkit-transform:rotate(330deg);-ms-transform:rotate(330deg);transform:rotate(330deg)}.loadingCirclePoint___3md-S:nth-of-type(6):before,.loadingCirclePoint___3md-S:nth-of-type(12):before{-webkit-animation-delay:-.2s;animation-delay:-.2s}.loadingCirclePoint___3md-S:nth-of-type(7){-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.loadingCirclePoint___3md-S:nth-of-type(13){-webkit-transform:rotate(1turn);-ms-transform:rotate(1turn);transform:rotate(1turn)}.loadingCirclePoint___3md-S:nth-of-type(7):before,.loadingCirclePoint___3md-S:nth-of-type(13):before{-webkit-animation-delay:0ms;animation-delay:0ms}.loadingContainer___2vaJ-{position:absolute;top:0;right:0;bottom:0;left:0}.loadingContainer__icon___1wQQz{color:#fff;position:absolute;top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);-ms-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}", ""]);
	
	// exports
	exports.locals = {
		"outer": "outer___2lDXy",
		"outerClosing": "outerClosing___1EQGK",
		"inner": "inner___1rfRQ",
		"image": "image___2FLq2",
		"imagePrev": "imagePrev___F6xVQ",
		"imageNext": "imageNext___1uRqJ",
		"imageDiscourager": "imageDiscourager___3-CUB",
		"navButtons": "navButtons___3kNVF",
		"navButtonPrev": "navButtonPrev___2vBS8",
		"navButtonNext": "navButtonNext___30R2i",
		"downloadBlocker": "downloadBlocker___3rU9-",
		"caption": "caption___3vDh_",
		"toolbar": "toolbar___1xYly",
		"captionContent": "captionContent___30kw2",
		"toolbarSide": "toolbarSide___3FYWk",
		"toolbarSideNoFlex": "toolbarSideNoFlex___KxqgW",
		"toolbarLeftSide": "toolbarLeftSide___8beAg",
		"toolbarLeftSideNoFlex": "toolbarLeftSideNoFlex___3O3cZ",
		"toolbarRightSide": "toolbarRightSide___1Sdfc",
		"toolbarRightSideNoFlex": "toolbarRightSideNoFlex___oa0FT",
		"toolbarItem": "toolbarItem___3WbMb",
		"toolbarItemChild": "toolbarItemChild___2U_MP",
		"builtinButton": "builtinButton___1zqo6",
		"builtinButtonDisabled": "builtinButtonDisabled___3uvqe",
		"closeButton": "closeButton___3BdAF",
		"zoomInButton": "zoomInButton___3xtuX",
		"zoomOutButton": "zoomOutButton___38PZx",
		"outerAnimating": "outerAnimating___2-fZi",
		"closeWindow": "closeWindow___2Hlon",
		"loadingCircle": "loadingCircle___3JNJg",
		"loadingCirclePoint": "loadingCirclePoint___3md-S",
		"pointFade": "pointFade___2RA5J",
		"loadingContainer": "loadingContainer___2vaJ-",
		"loadingContainer__icon": "loadingContainer__icon___1wQQz"
	};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	
	    var content = __webpack_require__(63);
	    var insertCss = __webpack_require__(68);
	
	    if (typeof content === 'string') {
	      content = [[module.id, content, '']];
	    }
	
	    module.exports = content.locals || {};
	    module.exports._getContent = function() { return content; };
	    module.exports._getCss = function() { return content.toString(); };
	    module.exports._insertCss = function(options) { return insertCss(content, options) };
	    
	    // Hot Module Replacement
	    // https://webpack.github.io/docs/hot-module-replacement
	    // Only activated in browser context
	    if (false) {
	      var removeCss = function() {};
	      module.hot.accept("!!../node_modules/css-loader/index.js?modules&-autoprefixer&importLoaders=1&localIdentName=[local]___[hash:base64:5]!../node_modules/postcss-loader/index.js!../node_modules/sass-loader/index.js!./style.scss", function() {
	        content = require("!!../node_modules/css-loader/index.js?modules&-autoprefixer&importLoaders=1&localIdentName=[local]___[hash:base64:5]!../node_modules/postcss-loader/index.js!../node_modules/sass-loader/index.js!./style.scss");
	
	        if (typeof content === 'string') {
	          content = [[module.id, content, '']];
	        }
	
	        removeCss = insertCss(content, { replace: true });
	      });
	      module.hot.dispose(function() { removeCss(); });
	    }
	  

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(32);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _slicedToArray2 = __webpack_require__(33);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Isomorphic CSS style loader for Webpack
	 *
	 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE.txt file in the root directory of this source tree.
	 */
	
	var prefix = 's';
	var inserted = {};
	
	// Base64 encoding and decoding - The "Unicode Problem"
	// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
	function b64EncodeUnicode(str) {
	  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
	    return String.fromCharCode('0x' + p1);
	  }));
	}
	
	/**
	 * Remove style/link elements for specified node IDs
	 * if they are no longer referenced by UI components.
	 */
	function removeCss(ids) {
	  ids.forEach(function (id) {
	    if (--inserted[id] <= 0) {
	      var elem = document.getElementById(prefix + id);
	      if (elem) {
	        elem.parentNode.removeChild(elem);
	      }
	    }
	  });
	}
	
	/**
	 * Example:
	 *   // Insert CSS styles object generated by `css-loader` into DOM
	 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
	 *
	 *   // Remove it from the DOM
	 *   removeCss();
	 */
	function insertCss(styles) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$replace = _ref.replace,
	      replace = _ref$replace === undefined ? false : _ref$replace,
	      _ref$prepend = _ref.prepend,
	      prepend = _ref$prepend === undefined ? false : _ref$prepend;
	
	  var ids = [];
	  for (var i = 0; i < styles.length; i++) {
	    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
	        moduleId = _styles$i[0],
	        css = _styles$i[1],
	        media = _styles$i[2],
	        sourceMap = _styles$i[3];
	
	    var id = moduleId + '-' + i;
	
	    ids.push(id);
	
	    if (inserted[id]) {
	      if (!replace) {
	        inserted[id]++;
	        continue;
	      }
	    }
	
	    inserted[id] = 1;
	
	    var elem = document.getElementById(prefix + id);
	    var create = false;
	
	    if (!elem) {
	      create = true;
	
	      elem = document.createElement('style');
	      elem.setAttribute('type', 'text/css');
	      elem.id = prefix + id;
	
	      if (media) {
	        elem.setAttribute('media', media);
	      }
	    }
	
	    var cssText = css;
	    if (sourceMap && typeof btoa === 'function') {
	      // skip IE9 and below, see http://caniuse.com/atob-btoa
	      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
	      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
	    }
	
	    if ('textContent' in elem) {
	      elem.textContent = cssText;
	    } else {
	      elem.styleSheet.cssText = cssText;
	    }
	
	    if (create) {
	      if (prepend) {
	        document.head.insertBefore(elem, document.head.childNodes[0]);
	      } else {
	        document.head.appendChild(elem);
	      }
	    }
	  }
	
	  return removeCss.bind(null, ids);
	}
	
	module.exports = insertCss;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(65);
	var invariant = __webpack_require__(66);
	var ReactPropTypesSecret = __webpack_require__(71);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(69)();
	}


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_72__;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_73__;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// react-image-lightbox.js